import React from 'react'
import { Table } from 'reactstrap';
import { News} from './index';

const NewsList = (props) => {
    const adminDisplay = () =>{
        if (props.displayType === "NewsManage"){
            return(
            <tr>
                <th className="news-list-date">登録日</th>
                <th className="news-list-content">お知らせ</th>
                <th className="news-list-operation">操作</th>
            </tr>
                )
        }else{
            return(
            <tr>
                <th className="news-list-date">登録日</th>
                <th className="news-list-content">お知らせ</th>
            </tr>
            )
        }
    }

    return(
        <div className= "news-list">
            <Table striped bordered style={{ tableLayout:"fixed"}}>
                <thead>
                    {adminDisplay()}
                </thead>
                <tbody>
                    {props.newsList.map((value, index) => {
                        return<News 
                            newsId={value.newsId}
                            newsText={value.newsText}
                            newsDate={value.newsDate}
                            editNewsInfo={props.editNewsInfo}
                            deleteNewsInfo={props.deleteNewsInfo}
                            key={index.toString()}
                            displayType={props.displayType} />
                    })}
                </tbody>
            </Table>
        </div>
    )
}

export default NewsList;